import { render, staticRenderFns } from "./Candidacies.vue?vue&type=template&id=51196aa8&"
import script from "./Candidacies.vue?vue&type=script&lang=js&"
export * from "./Candidacies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports